import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "emailField"]

  toggle() {
    if (this.checkboxTarget.checked) {
      this.emailFieldTarget.classList.remove("hidden")
    } else {
      this.emailFieldTarget.classList.add("hidden")
    }
  }
}
